import cn from 'classnames';
import BellIcon from '@/assets/icon/components/BellIcon';
import styles from './notificationBell.module.scss';

interface INotificationBellProps {
  count: number;
  isActive: boolean;
  onClick: () => void;
  isDisabled?: boolean;
}

const MAX_BADGE_COUNT = 99;
const ENABLED_LABEL = 'Уведомления';
const DISABLED_LABEL = 'Уведомления временно отключены';

/**
 * Кнопка-колокольчик в шапке с бейджем непрочитанных. Число берётся из
 * `unviewedOrders` (единый источник с фавиконом). Клик открывает/закрывает
 * панель уведомлений.
 *
 * В состоянии `isDisabled` кнопка заблокирована и бейдж не показывается —
 * центр уведомлений выведен из работы до появления отдельного сервиса.
 */
export const NotificationBell: React.FC<INotificationBellProps> = ({
  count,
  isActive,
  onClick,
  isDisabled = false
}) => {
  const badgeLabel = count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : count;
  const label = isDisabled ? DISABLED_LABEL : ENABLED_LABEL;

  return (
    <button
      type="button"
      className={cn(styles['notification-bell'], {
        [styles['notification-bell_active']]: isActive,
        [styles['notification-bell_disabled']]: isDisabled
      })}
      onClick={onClick}
      disabled={isDisabled}
      aria-label={label}
      aria-expanded={isActive}
      title={label}
    >
      <BellIcon width={20} height={20} color="#fff" />
      {!isDisabled && count > 0 && (
        <span className={styles['notification-bell__badge']}>{badgeLabel}</span>
      )}
    </button>
  );
};
